import axios from "axios"

export function isRequestCanceled(error) {
  return axios.isCancel(error) || error?.code === "ERR_CANCELED"
}
